import ConfigService from 'shared/services/config.service';
import { jsonParser } from 'shared/utils';

export const getSupportedCaseStatuses = () => {
  const parsedStatues = jsonParser<string[]>(ConfigService.getConfigValue('Settings', 'SupportedCaseSearchStatuses'));
  return parsedStatues || [];
};
